import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { FoodAlcoholModel, FoodAlcoholFilterSettingsModel } from "../models/foodAndAlcohol";
import AuthService from './authService';
class FoodAlcoholService {
  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  //TODO: add filtersetting object
  getAllFoodAlcohols(from: number, numberOfRows: number, settings: FoodAlcoholFilterSettingsModel) {
    return axios({
      url: `adminFoodAlcohol/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getFoodAlcohol(id: number) {
    return axios({
      url: `adminFoodAlcohol/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  addFoodAlcohol(foodAlcohol: FoodAlcoholModel) {
    return axios({
      url: `adminFoodAlcohol/createFoodAlcohol`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(foodAlcohol)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editFoodAlcohol(id: number, foodAlcohol: FoodAlcoholModel) {
    return axios({
      url: `adminFoodAlcohol/updateFoodAlcohol/${id}`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(foodAlcohol)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteFoodAlcohol(id: number) {
    return axios({
      url: `adminFoodAlcohol/deleteFoodAlcohol/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDropdownList() {
    return axios({
      url: `adminFoodAlcohol/getDropdownList/`,
      method: 'get', headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default FoodAlcoholService;
